// @flow
import React from "react";
import TechnicalIssue from "../../TechnicalIssue/TechnicalIssue";
import {connect} from "react-redux";
import TokenDataSelectors from "../../../Store/Ducks/TokenData/selectors";

type ConnectedProps = {|
    tokenError: string,
|}

const TokenError = (props: ConnectedProps) => {
    return (
        <TechnicalIssue labels={[props.tokenError]}/>
    );
};
const mapStateToProps = (state, props) => {
    return {
        tokenError: TokenDataSelectors.getTokenDataError(state),
    };
};
export default connect(mapStateToProps)(TokenError);



// WEBPACK FOOTER //
// ./src/Components/Screen/ExpiredToken/TokenError.js